// Shared wrapper for legal pages — header, back link, prose container.
import { Link } from "react-router-dom";
import { C } from "../theme.js";

const BRAND_LOGO_SRC = "/icon.png";

export function LegalLayout({ title, lastUpdated, children }) {
  return (
    <div style={{ minHeight: "100vh", background: C.cream }}>
      {/* Nav */}
      <div style={{
        background: C.white, borderBottom: `1px solid ${C.border}`,
        padding: "14px 20px", display: "flex", alignItems: "center", gap: 16,
      }}>
        <Link to="/" style={{
          color: C.green, fontWeight: 700, fontSize: 14, textDecoration: "none",
          display: "flex", alignItems: "center", gap: 6,
        }}>
          ‹ Back to NomLoop
        </Link>
        <span style={{ color: C.greyLight }}>|</span>
        <span style={{
          display: "inline-flex", alignItems: "center", gap: 7,
          fontFamily: "Lora, Georgia, serif", fontWeight: 700,
          fontSize: 15, color: C.charcoal,
        }}>
          <img
            src={BRAND_LOGO_SRC}
            alt=""
            width={22}
            height={22}
            style={{ width: 22, height: 22, borderRadius: 6, objectFit: "cover", display: "block" }}
          />
          NomLoop
        </span>
      </div>

      {/* Content */}
      <div style={{ maxWidth: 720, margin: "0 auto", padding: "40px 24px 80px" }}>
        <h1 style={{
          fontFamily: "Lora, Georgia, serif", fontSize: 32, fontWeight: 700,
          color: C.charcoal, marginBottom: 8,
        }}>{title}</h1>
        {lastUpdated && (
          <p style={{ color: C.grey, fontSize: 13, marginBottom: 40 }}>
            Last updated: {lastUpdated}
          </p>
        )}
        <div style={{ fontSize: 15, lineHeight: 1.8, color: C.charcoal }}>
          {children}
        </div>
      </div>
    </div>
  );
}

// Reusable prose elements
export function H2({ children }) {
  return (
    <h2 style={{
      fontFamily: "Lora, Georgia, serif", fontSize: 20, fontWeight: 700,
      color: C.charcoal, marginTop: 40, marginBottom: 12,
    }}>{children}</h2>
  );
}

export function P({ children, style }) {
  return <p style={{ marginBottom: 14, ...style }}>{children}</p>;
}

export function Ul({ children }) {
  return (
    <ul style={{ paddingLeft: 24, marginBottom: 14 }}>
      {children}
    </ul>
  );
}

export function Li({ children }) {
  return <li style={{ marginBottom: 6 }}>{children}</li>;
}

export function A({ href, children }) {
  return <a href={href} style={{ color: C.green, fontWeight: 600 }}>{children}</a>;
}
